import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { getTranslation } from 'helpers/getTranslation';
import { idxMap } from 'helpers/styleMapIdx';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import styles from './PlatformChip.module.scss';

const PLATFORM_ICONS = {
  Web: 'browser',
  Plugin: 'figma',
};

const PLATFORM_TRANSLATION_KEYS = {
  Web: 'common.text.web',
  Plugin: 'common.text.plugin',
};

/** DS "Course type" chip (Figma 161:7328) with a platform icon. */
const PlatformChip = ({
  className,
  platform,
}: {
  className?: string;
  platform: string;
}) => {
  // Subscribes the memoized chip to language switches (the label is translated at render).
  useTranslation();
  const iconName = idxMap(PLATFORM_ICONS as Record<string, string>, platform);
  const translationKey = idxMap(
    PLATFORM_TRANSLATION_KEYS as Record<string, string>,
    platform,
  );

  return (
    <div
      className={cn(
        styles.chip,
        { [styles.chipWithIcon]: iconName },
        className,
      )}
    >
      {iconName ? <Icon className={styles.icon} name={iconName} /> : null}
      <Typography
        className={styles.text}
        component="span"
        variant="body3"
        mode="compact"
      >
        {translationKey ? getTranslation(translationKey) : platform}
      </Typography>
    </div>
  );
};

export default React.memo(PlatformChip) as any;
